<template>
	<b-container v-if="isLoggedIn&&userProfile.memberId" fluid v-animate-css="'fadeIn'" class="profileView">
		<b-row>
			<b-col class="profileForm" v-if="!userProfile.profileComplete||!userProfile.phoneVerified">
				<div id="step1" v-if="userProfile.profileComplete&&!userProfile.phoneVerified">
					<div class="formTitle">
						<svg-image image="iconPhone"/>
						<h5>{{ $t("validate.phone.head") }}</h5>
					</div>
					<b-form @submit="onPhone">
						<b-form-group id="phone-group"
							label-for="phone"
							label=""
							:description="$t('validate.phone.desc')"
						>
							<b-form-group :label="$t('validate.phone.label')" id="phone-group" label-for="phone" 
						 v-if="!otpSent">
								<VuePhoneNumberInput no-example class="form-group" color="#ea0c0c" :border-radius="0" required v-model="form_.phone" default-country-code="ID" @update="phoneUpdated"/>
								<b-input-group-append>
									<b-button block variant="outline-primary" :disabled="checkingPhone" @click="sendOTP">
										<b-spinner v-if="checkingPhone" small></b-spinner>
										<span> {{ $t("validate.phone.send") }}</span>
									</b-button>
								</b-input-group-append>
							</b-form-group>
							<b-input-group v-if="otpSent" :label="$t('validate.otp.label')">
								<b-form-input
									id="otpCode"
									v-model="formPhone.otpCode"
									type="number"
									required
									:placeholder="$t('validate.otp.place')"
									:state="phoneState.state"
									:disabled="checkingPhone||phoneChecked"
								></b-form-input>
								<b-input-group-append>
									<b-button variant="primary" :disabled="!formPhone.otpCode" @click="validatePhoneOTP">
										<b-spinner v-if="checkingPhone" small></b-spinner>
										<span> {{ $t("validate.otp.btnv") }}</span>
									</b-button>
									<!-- <b-button variant="danger" v-if="showResend" @click="resetPhone">
										<b-spinner v-if="checkingPhone" small></b-spinner>
										<span> {{ $t("validate.otp.btnr") }}</span>
									</b-button> -->
									<b-button variant="warning" v-if="showLater" @click="validateLater">
										<b-spinner v-if="checkingPhone" small></b-spinner>
										<span> {{ $t("validate.otp.later") }}</span>
									</b-button>
								</b-input-group-append>
							</b-input-group>
							<b-form-invalid-feedback :state="phoneState.state">
								{{phoneState.message}}
							</b-form-invalid-feedback>
							<b-form-valid-feedback :state="phoneState.state">
								{{phoneState.message}}
							</b-form-valid-feedback>
						</b-form-group>
					</b-form>
				</div>
				<!-- <hr> -->
				<div id="step2" v-if="!userProfile.profileComplete&&!fileUploaded">
					<div class="formTitle">
							<svg-image image="iconID"/>
							<h5>{{ $t("validate.id.head") }}</h5>
					</div>
					<div v-if="fileError">
						<hr/>
							<div class="successAlert">
							<svg-image image="iconReject"/>
							<div v-html="$t('validate.alert.reject')"></div>
							</div>
						<hr/>
					</div>
					<b-form @submit="onFile">
						<b-form-group id="idType-group" :label="$t('validate.id.labeltype')" label-for="idType">
							<b-form-select
								id="idType"
								v-model="form.mbsdIDNumberType"
								:options="idTypes"
								:state="formStatus.mbsdIDNumberType.state"
								required
							></b-form-select>
						</b-form-group>
						<b-form-group id="idFile-group" :label="$t('validate.id.labelfile')" label-for="idFile" :description="$t('validate.id.descfile')">
							<b-form-file
								v-model="idFile"
								:placeholder="$t('validate.id.placefile')"
								:drop-placeholder="$t('validate.id.dropfile')"
								@change="handleFileUpload"
								accept=".jpg, .png, .jpeg"
							></b-form-file>
							<!-- <b-progress :value="progress" class="mb-3"></b-progress> -->
							<b-progress class="mt-2" :max="200" height="2.5rem">
								<b-progress-bar :value="progress">
									{{progressAction}}<strong>{{ progress/2 }}</strong>
								</b-progress-bar>
							</b-progress>
							<div><label class="fileLabel">{{ $t("validate.id.labelselect") }} {{ idFile ? idFile.name : '' }}</label></div>
						</b-form-group>
						<alert :status="status"/>
						<div class="clearfix">
							<b-button block type="submit" variant="primary" :disabled="loading||!fileSelected"><b-spinner v-if="loading" small type="grow"></b-spinner> {{ $t("validate.id.btn") }}</b-button>
						</div>
					</b-form>
				</div>
				<!-- <hr> -->
				<div id="step3" v-if="fileUploaded&&!userProfile.profileComplete">
				<!-- <div id="step3"> -->
					<div class="formTitle">
							<svg-image image="iconOne"/>
							<h5>{{ $t("validate.data.head") }}</h5>
					</div>
					<b-form @submit="onData">
						<b-form-group id="idNumber-group" :label="$t('validate.data.idlabel')" label-for="idNumber" :description="$t('validate.data.iddesc')">
							<b-form-input
								id="idNumber"
								v-model="form.mbsdIDNumber"
								:state="formStatus.mbsdIDNumber.state"
								required
							></b-form-input>
						</b-form-group>
						<b-form-group id="birthDate-group" :label="$t('validate.data.doblabel')" label-for="birthDate" :description="$t('validate.data.dobd')">
							<!-- <b-form-datepicker
								id="birthDate"
								v-model="form.mbsdBirthDate"
								:state="formStatus.mbsdBirthDate.state"
								required
							></b-form-datepicker> -->
							<datetime id="birthDate"
								v-model="form.mbsdBirthDate"
								:state="formStatus.mbsdBirthDate.state"
								:max-datetime="'20061115'"
								value-zone="Asia/Jakarta"
								required
							></datetime>
						</b-form-group>
						<b-form-group id="birthPlace-group" :label="$t('validate.data.poblabel')" label-for="birthPlace" :description="$t('validate.data.pobd')">
							<gmap-autocomplete
								class="form-control"
								id="birthPlace"
								@place_changed='setBirthPlace'
								:state="formStatus.mbsdBirthPlace.state"
								:value='form.mbsdBirthPlace'
								:options="birthplaceOptions"
								required
							/>
						</b-form-group>
						<b-form-group id="bloodType-group" :label="$t('validate.data.blo')" label-for="bloodType">
							<b-form-select
								id="bloodType"
								v-model="form.mbsdBloodType"
								:options="bloodType"
								:state="formStatus.mbsdBloodType.state"
								required
							></b-form-select>
						</b-form-group>
						<b-form-group id="nationality-group" :label="$t('validate.data.nat')" label-for="nationality">
							<v-select v-model="form.mbsdNationality" :state="formStatus.mbsdNationality.state" :options="countries" label="name" :reduce="country => country.code" ></v-select>
						</b-form-group>
						<b-form-group id="country-group" :label="$t('validate.data.cou')" label-for="country">
							<v-select v-model="form.mbsdCountry" :options="countries" label="name" :state="formStatus.mbsdCountry.state" :reduce="country => country.code" @input="setCountryRestriction"></v-select>
						</b-form-group>

						<b-form-group v-if="form.mbsdCountry&&form.mbsdCountry=='ID'" id="address-group" :label="$t('validate.data.dom')" :description="$t('validate.data.domdesc')" class="addressForm" label-for="address">
							<b-form-input class="mt-2" v-model="form.mbsdAddress" :placeholder="$t('validate.data.add')"></b-form-input>
							<v-select class="mt-2" @search="fetchOptions" :options="fetchedOptions" :placeholder="$t('validate.data.cit')" label="label" @input='citySelected'/>
							<b-form-input class="mt-2" v-model="form.mbsdProvinces" :placeholder="$t('validate.data.pro')" disabled></b-form-input>
						</b-form-group>
						<b-form-group v-if="form.mbsdCountry&&form.mbsdCountry!='ID'" id="address-group" :label="$t('validate.data.dom')" label-for="address">
							<!-- <b-form-input class="mt-2" v-model="form.mbsdCity" :placeholder="$t('validate.data.cit')" disabled></b-form-input> -->
							<gmap-autocomplete
								class="form-control"
								id="address"
								@place_changed='setAddress'
								:value='form.mbsdAddress'
								:options="addressOptions"
								:state="formStatus.mbsdAddress.state"
								required
								placeholder=""
							/>
							<b-form-input class="mt-2" v-model="form.mbsdCity" :placeholder="$t('validate.data.cit')" disabled></b-form-input>
							<b-form-input class="mt-2" v-model="form.mbsdProvinces" :placeholder="$t('validate.data.pro')" disabled></b-form-input>
						</b-form-group>
						
						<b-form-group id="education-group" :label="$t('validate.data.edu')" label-for="education" description="">
							<b-form-select v-model="form.mmedEducation">
								<b-form-select-option value="Elementary">{{ $t("validate.select.edu.e1") }}</b-form-select-option>
								<b-form-select-option value="Junior">{{ $t("validate.select.edu.e2") }}</b-form-select-option>
								<b-form-select-option value="Senior">{{ $t("validate.select.edu.e3") }}</b-form-select-option>
								<b-form-select-option value="Diploma">{{ $t("validate.select.edu.e4") }}</b-form-select-option>
								<b-form-select-option value="Bachelor">{{ $t("validate.select.edu.e5") }}</b-form-select-option>
								<b-form-select-option value="Master">{{ $t("validate.select.edu.e6") }}</b-form-select-option>
								<b-form-select-option value="Doctorate">{{ $t("validate.select.edu.e7") }}</b-form-select-option>
							</b-form-select>
						</b-form-group>
						<b-form-group id="occupation-group" :label="$t('validate.data.ocu')" label-for="occupation" description="">
							<b-form-select v-model="form.mmedOccupation">
								<b-form-select-option value="Business">{{ $t("validate.select.ocu.o1") }}</b-form-select-option>
								<b-form-select-option value="Civil">{{ $t("validate.select.ocu.o2") }}</b-form-select-option>
								<b-form-select-option value="Educational">{{ $t("validate.select.ocu.o3") }}</b-form-select-option>
								<b-form-select-option value="Entrepreneur">{{ $t("validate.select.ocu.o4") }}</b-form-select-option>
								<b-form-select-option value="Freelance">{{ $t("validate.select.ocu.o5") }}</b-form-select-option>
								<b-form-select-option value="Healthcare">{{ $t("validate.select.ocu.o6") }}</b-form-select-option>
								<b-form-select-option value="Industrial">{{ $t("validate.select.ocu.o7") }}</b-form-select-option>
								<b-form-select-option value="Law">{{ $t("validate.select.ocu.o8") }}</b-form-select-option>
								<b-form-select-option value="Private">{{ $t("validate.select.ocu.o9") }}</b-form-select-option>
								<b-form-select-option value="Professional">{{ $t("validate.select.ocu.o10") }}</b-form-select-option>
								<b-form-select-option value="Student">{{ $t("validate.select.ocu.o11") }}</b-form-select-option>
								<b-form-select-option value="Unemployed">{{ $t("validate.select.ocu.o12") }}</b-form-select-option>
								<b-form-select-option value="Others">{{ $t("validate.select.ocu.o13") }}</b-form-select-option>
							</b-form-select>
						</b-form-group>
						<b-form-group id="income-group" :label="$t('validate.data.inc')" label-for="income" description="">
							<b-form-select v-model="form.mmedIncome">
								<b-form-select-option value="income1">{{ $t("validate.select.inc.i1") }}</b-form-select-option>
								<b-form-select-option value="income2">{{ $t("validate.select.inc.i2") }}</b-form-select-option>
								<b-form-select-option value="income3">{{ $t("validate.select.inc.i3") }}</b-form-select-option>
								<b-form-select-option value="income4">{{ $t("validate.select.inc.i4") }}</b-form-select-option>
								<b-form-select-option value="income5">{{ $t("validate.select.inc.i5") }}</b-form-select-option>
								<b-form-select-option value="income6">{{ $t("validate.select.inc.i6") }}</b-form-select-option>
							</b-form-select>
						</b-form-group>

						<b-form-checkbox
							id="acceptanceNEWS"
							v-model="checkBoxes.agreeNewsletter"
							name="acceptanceNEWS"
							value="accepted"
							unchecked-value="not_accepted"
							@change="doNewsCheckbox"
							>
							{{ $t("validate.data.accnews") }}
						</b-form-checkbox>
						<b-form-checkbox
							id="acceptance"
							v-model="checkBoxes.validIdentity"
							name="acceptance"
							value="accepted"
							unchecked-value="not_accepted"
							>
							{{ $t("validate.data.accok") }}
						</b-form-checkbox>
						<b-form-checkbox
							id="acceptanceTC"
							v-model="checkBoxes.agreeOnTnC"
							name="acceptanceTC"
							value="accepted"
							unchecked-value="not_accepted"
							>
							<div v-html="$t('validate.data.acctnp')"></div>
						</b-form-checkbox>
						<alert :status="status"/>
						<div class="clearfix">
							<b-button block type="submit" variant="primary" size="lg" :disabled="loading||checkBoxes.validIdentity!=='accepted'||checkBoxes.agreeOnTnC!=='accepted'"><b-spinner v-if="loading" small type="grow"></b-spinner> {{ $t("validate.data.btn") }}</b-button>
						</div>
					</b-form>
				</div>
				<!-- <hr/>
				<b-card class="mt-3" header="Form Data Result">
					<pre class="m-0">{{ form }}</pre>
				</b-card>
				<b-card class="mt-3" header="Session Output">
					<pre>{{userProfile}}</pre>
				</b-card> -->
			</b-col>
			<b-col v-if="userProfile.profileComplete&&userProfile.phoneVerified" class="personalData">
				<div style="padding: 0 1rem">
				<div class="userProfile" v-if="userProfile.profileData">
					<!-- {{userProfile.profileData.mbsdFile}} -->
					<img v-if="userProfile.profileData.mbsdFile" :src="'https://facepool.oss-ap-southeast-5.aliyuncs.com/'+userProfile.profileData.mbsdFile" @error="photoProfileError" class="avatar">
					<h4>{{userProfile.profileData.mbsdFullName}}</h4>
					<div class="profileStatus">
						<div class="profileVerified" v-if="isVerified">
							<span><b-icon icon="person-fill" variant="light"></b-icon>{{ $t("profile.status.verified") }}</span>
						</div>
						<div class="profilePending" v-if="isVerifying">
							<span><b-icon icon="clock-fill" variant="light"></b-icon>{{ $t("profile.status.verifying") }}</span>
						</div>
						<div class="profileFailed" v-if="isFailed&&!isVerifying==true">
							<span><b-icon icon="alert-triangle-fill" variant="light"></b-icon>{{ $t("profile.status.failed") }}</span>	
						</div>
						<div class="profilePending" v-if="isFailed&&!isVerifying==true">
							<span><b-icon icon="clock-fill" variant="light"></b-icon>{{ $t("profile.status.pending") }}</span>
						</div>
					</div>
					<b-alert show variant="warning" v-if="isFailed||isVerifying==true||!isVerified"><span v-html="$t('profile.pendingmsg')"></span></b-alert>

					<b-button pill variant="outline-secondary" size="sm" @click="updateProfile" v-if="!isVerified"><b-icon icon="pen"></b-icon> {{ $t("profile.updatebtn") }}</b-button>
					
					<!-- <b-button pill variant="outline-secondary" size="sm" v-if="!isVerified"><b-icon icon="cone-striped"></b-icon> {{ $t("profile.reqbtn") }}</b-button> -->
					<!-- <b-alert show variant="warning"><b-icon icon="alert-circle"></b-icon> {{ $t("profile.reqmsg") }}</b-alert> -->

					<b-button pill variant="outline-secondary" size="sm" v-if="!resetPasswordSent" @click="resetPassword"><b-icon icon="arrow-counterclockwise"></b-icon> {{ $t("profile.resetbtn") }}</b-button>
					<b-alert v-if="resetPasswordSent" show variant="warning"><b-icon icon="alert-circle"></b-icon> {{ $t("profile.resetmsg") }}</b-alert>
					
					<!-- <div class="regStatus">
						<label>Registration Status</label>
						<b-alert show variant="warning"><b-icon-stopwatch-fill></b-icon-stopwatch-fill> Waiting for Ballot Drawing</b-alert>
					</div> -->
				</div>
				<alert :status="status"/>
				<b-card-group v-if="userProfile.profileData" deck>
					<b-card :header="$t('profile.card.details.head')">
						<p><strong>{{ $t("profile.card.details.nat") }}</strong>: {{userProfile.profileData.mbsdNationality}}</p>
						<p><strong>{{ $t("profile.card.details.gen") }}</strong>: {{userProfile.profileData.mbsdGender | gender}}</p>
						<p><strong>{{ $t("profile.card.details.blo") }}</strong>: {{userProfile.profileData.mbsdBloodType | bloodType}}</p>
						<p><strong>{{ $t("profile.card.details.dob") }}</strong>: {{userProfile.profileData.mbsdBirthDate | moment("D MMMM YYYY")}}</p>
						<p><strong>{{ $t("profile.card.details.pob") }}</strong>: {{userProfile.profileData.mbsdBirthPlace}}</p>
					</b-card>
					<b-card :header="$t('profile.card.id.head')">
						<p><strong>{{ $t("profile.card.id.typ") }}</strong>: {{userProfile.profileData.mbsdIDNumberType | cardType}}</p>
						<p><strong>{{ $t("profile.card.id.num") }}</strong>: {{userProfile.profileData.mbsdIDNumber}}</p>
						<p v-if="userProfile.otherInfo"><strong>{{ $t("profile.card.id.edu") }}</strong>: {{userProfile.otherInfo.mmedEducation}}</p>
						<p v-if="userProfile.otherInfo"><strong>{{ $t("profile.card.id.ocu") }}</strong>: {{userProfile.otherInfo.mmedOccupation}}</p>
					</b-card>
					<b-card :header="$t('profile.card.com.head')">
						<p><strong>{{ $t("profile.card.com.ema") }}</strong>: {{userProfile.profileData.mbsdEmail}}</p>
						<p v-if="userProfile.phoneData&&userProfile.phoneData.mbspCountryCode&&userProfile.phoneData.mbspNumber"><strong>{{ $t("profile.card.com.pho") }}</strong>: +{{userProfile.phoneData.mbspCountryCode}}{{userProfile.phoneData.mbspNumber}}</p>
						<p><strong>{{ $t("profile.card.com.add") }}</strong>: {{userProfile.profileData.mbsdAddress}}</p>
						<p><strong>{{ $t("profile.card.com.cit") }}</strong>: {{userProfile.profileData.mbsdCity}}</p>
						<p><strong>{{ $t("profile.card.com.pro") }}</strong>: {{userProfile.profileData.mbsdProvinces}}</p>
						<p><strong>{{ $t("profile.card.com.cou") }}</strong>: {{userProfile.profileData.mbsdCountry}}</p>
					</b-card>
				</b-card-group>
				<div class="text-center mb-3">
				<b-button to="/" pill variant="outline-secondary"><b-icon icon="arrow-left"></b-icon> {{ $t("profile.dash") }}</b-button>
				</div>
				<!-- <b-card class="mt-3" header="Session Output">
					<pre>{{userProfile}}</pre>
				</b-card> -->
				</div>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
	import VuePhoneNumberInput from 'vue-phone-number-input';
   	import Alert from '../components/Alert.vue';
	import { gmapApi } from '../../node_modules/vue2-google-maps';
	import * as utils from '../util/utils';
	import SvgImage from '../components/SvgImage.vue';
	export default {
		data() {
			return {
				fetchedOptions : [],
				fileSelected : false,
				isVerifying : false,
				isFailed : false,
				isVerified : false,
				checkBoxes : {
					validIdentity : false,
					agreeOnTnC : false
				},
				otpSent : false,
				otpError : false,
				userProfile : {},
				phoneState : {
					state : null,
					message : undefined
				},
				phoneChecked : undefined,
				progress: 0,
				idFile: undefined,
				progressAction: undefined,
				fileUploaded: undefined,
				form_ : {
					phone : undefined
				},
				birthplaceOptions : {
					types: ['(cities)'],
					// componentRestrictions: {country: "id"}
				},
				addressOptions : {
					types: [],
					// componentRestrictions: {country: "id"}
				},
				form: {
					"mbsdIDNumberType": undefined,
					"mbsdIDNumber": undefined,
					"mbsdBirthDate": undefined,
					"mbsdBirthPlace": undefined,
					"mbsdNationality": undefined,
					"mbsdCountry": undefined,
					"mbsdProvinces": undefined,
					"mbsdCity": undefined,
					"mbsdAddress": undefined,
					"mbsdRawAddress": '-',
					"mbsdFile": undefined
				},
				formPhone: {
					mbspCountryCode: undefined,
					mbspNumber: undefined
				},
				formStatus: {
					"mbsdIDNumberType": {
						state : null
					},
					"mbsdIDNumber": {
						state : null
					},
					"mbsdBirthDate": {
						state : null
					},
					"mbsdBirthPlace": {
						state : null
					},
					"mbsdNationality": {
						state : null
					},
					"mbsdCountry": {
						state : null
					},
					"mbsdProvinces": {
						state : null
					},
					"mbsdCity": {
						state : null
					},
					"mbsdAddress": {
						state : null
					},
					"mbsdRawAddress": {
						state : null
					},
					"mbsdFile": {
						state : null
					},
					"mbsdBloodType": {
						state : null
					}
				},
				idTypes: [
					{ text: 'KTP / National ID', value: 0 },
					{ text: 'SIM / Driver License', value: 1 },
					{ text: 'Paspor / Passport', value: 2 },
				],
				bloodType:[
					{ text: 'O', value: 0 },
					{ text: 'O+', value: 1 },
					{ text: 'O-', value: 2 },
					{ text: 'A', value: 3 },
					{ text: 'A+', value: 4 },
					{ text: 'A-', value: 5 },
					{ text: 'B', value: 6 },
					{ text: 'B+', value: 7 },
					{ text: 'B-', value: 8 },
					{ text: 'AB', value: 9 },
					{ text: 'AB+', value: 10 },
					{ text: 'AB-', value: 11 },
				],
				countries:undefined,
				signedin : true,
				data: null,
				status: null,
				loading:false,
				checkingPhone: false,
				resetPasswordSent: false,
				fileError: undefined,
				showLater : false
			}
		},
		computed : {
			isLoggedIn : function(){ 
				// console.log('is this one logged in? ', this.$store.getters.isLoggedIn);
				return this.$store.getters.isLoggedIn
			},
			showResend : function(){
				return true
			},
			// getProfile : function(){
			// 	const userProfile = this.$store.getters.getUserProfile;
			// 	if (userProfile.phoneData){
			// 		this.formPhone = userProfile.phoneData;
			// 	}
			// 	return userProfile;
			// }
		},
		components : {
			Alert,
			gmapApi,
			VuePhoneNumberInput,
			SvgImage,
		},
		methods: {
			resetPassword(){
				console.log(this.form)
				this.$store.dispatch('RESETPASSWORD', {data:{email:this.userProfile.profileData.mbsdEmail}})
					.then((resetOut) =>{
						this.loading = false;
						this.resetPasswordSent = true;
					})
					.catch(err => {
						this.loading = false;
						this.validation = false;
						if (err.response){
							this.status = err.response;
						}
					})
				// RESETPASSWORD
			},
			validateLater(){
				this.userProfile.phoneVerified = true;
			},
			citySelected(s){
				if (s.mskbProvinsi){				
					this.form.mbsdProvinces = s.mskbProvinsi;
					this.form.mbsdRawAddress = this.form.mbsdAddress;
					this.form.mbsdCity = s.mskbKabupaten;
				}
				// console.log('Selected : ',s);
			},
			fetchOptions(search, isLoading){
				if (search&&search.length > 2){				
					isLoading = true;
					this.doSearch(isLoading, search, this);
				}
			},
			doSearch(isLoading, search, vm){
				this.$store.dispatch('GETRESOURCE', {source:'masterKabupaten', params:{
						sort: 'mskbId',
						filter:{mskbKabupaten:{like:'%'+search+'%'}}}
					}).then(resources=>{
						if (resources.data.data&&resources.data.data.length > 0){
							resources.data.data.forEach(function(d){
								d.label = d.mskbKabupaten + ' - ' + d.mskbProvinsi
								// console.log(d);
							})
							vm.fetchedOptions = resources.data.data;
						}
						isLoading = false;
						// console.log(resources, vm);
					})
			},
			photoProfileError(event){
				event.target.src = "/public/images/anonymous.jpg"
				// console.log(this, event)
			},
			resetPhone(){
				this.otpSent = false;
				// this.userProfile.phoneData = {};
				// otpError
			},
			validatePhoneOTP(evt){
				this.$store.dispatch('VERIFYPHONE', {data:this.formPhone.otpCode})
					.then((phoneVerificationOut) =>{
						this.loading = false;
						console.log('A: ', phoneVerificationOut.data);
						// if (phoneVerificationOut.data.status='OK'){
							// this.showOtp = false;
							// console.log('B: ',signUp)
							this.$router.push('/');
							this.status = null;
						// }
					})
					.catch(err => {
						// console.log(err)
						// this.parseError(err);
						if (err.response){
							this.status = err.response;
							this.phoneState.state = false;
							this.phoneState.message = utils.stringifyErrors(err.response);
							this.otpError = true;
						} else {
							this.status = {data:{status:{error:{message:'Verification failed, please report this problem to info@borobudurmarathon.com'}}}}
						}
						this.loading = false;
					})
			},
			handleFileUpload(e){
				console.log(e)
				this.fileSelected = true;
			},
			parseError(err){
				if (err.response&&err.response.data&&err.response.data.status&&err.response.data.status.error){
					console.log('E1: ', err.response.data.status.error)
					console.log('E2: ', err.response.data.status.error.errors)
					if (err.response.data.status.error.errors&&err.response.data.status.error.errors.length > 0){
						err.response.data.status.error.errors.forEach((errors)=>{
							console.log('E3: ', errors);
							if (Array.isArray(errors)){
								errors.forEach((error)=>{
									console.log('E4: ', error);	
									if (this.formStatus[error.field]){									
										this.formStatus[error.field].state = false;
										this.formStatus[error.field].message = error.message;
									} else {
										console.log(error.field, ' not defined.');
									}
								})
							}
						})
					}
				}
			},
			setCountryRestriction(country){
				console.log('restrict google address search to : ', country);
				this.addressOptions.componentRestrictions = {country:country};
			},
			setAddress(place){
				var placeOut = utils.gParser(place);
				this.form.mbsdProvinces = placeOut.province;
				this.form.mbsdCity = placeOut.kabupaten;
				this.form.mbsdAddress = placeOut.address;
				if (placeOut.raw){
					this.form.mbsdRawAddress = placeOut.raw;
				}
				console.log(placeOut);
			},
			setBirthPlace(place){
				this.form.mbsdBirthPlace = place.formatted_address;
				// console.log(place.formatted_address);
			},
			startChecking() {
				if (this.fileCheckingInterval){
					clearInterval(this.fileCheckingInterval);
				}
				this.fileCheckingInterval = setInterval(()=>{
					this.$store.dispatch('CHECKID', {data:this.form})
						.then(validationOut=>{
							console.log('Validation Output : ', validationOut)
							if (validationOut.data.data.fivaStatus < 0){
								console.log('Unable to read document... ');
								this.fileUploaded = false;
								this.fileError = true;
								clearInterval(this.fileCheckingInterval);
							} else if (validationOut.data.data.fivaStatus > 1){
								console.log('Document OK ... ', validationOut.data.data);
								clearInterval(this.fileCheckingInterval);								
							}
						})
						.catch(err=>{
							console.log('Validation Err : ', err)
						})
					// this.checkId(data)
					// 	.then(checkResponse=>{
					// 		console.log(checkResponse);
					// 	})
					// 	.catch(err=>{
					// 		clearInterval(this.startChecking) 
					// 	})
				}, 5000);
			},
			onFile(evt){
				this.loading = true;
				evt.preventDefault()
				this.progressAction = 'Uploading File...';
				let formData = new FormData();
				let idType = 'ktp';
				if (this.form.mbsdIDNumberType == 1){
					idType = 'sim';
				} else if (this.form.mbsdIDNumberType == 2){
					idType = 'passport';
				}
				formData.append(idType,this.idFile);
				console.log('Process upload...');
				// console.log(formData);
				this.$store.dispatch('UPLOADID', {data:formData, progressEvent:(progressEvent)=>{
					this.progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 200 ))
					// console.log('progress : ', this.progress)
				}}).then((uploadOut) =>{
						this.loading = false;
						var fileUploadOut = uploadOut.data;
						this.form.mbsdFile = fileUploadOut.processingId;
						console.log('Upload success : ', fileUploadOut);
						this.fileUploaded = true;
						// this.startChecking(this.form);
					})
					.catch(err => {
						this.parseError(err);
						// if (err.response){
						// 	this.status = err.response;
						// }
						this.loading = false;
					})

			},
			onFileOldValidator(evt){
				this.loading = true;
				evt.preventDefault()
				this.progressAction = 'Uploading File...';
				let formData = new FormData();
				formData.append('file',this.idFile);
				// console.log(formData);
				this.$store.dispatch('UPLOADID', {data:formData, progressEvent:(progressEvent)=>{
					this.progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ))
					// console.log('progress : ', this.progress)
				}}).then((uploadOut) =>{
						this.loading = true;
						var fileUploadOut = uploadOut.data;
						console.log('Upload success : ', fileUploadOut);
						var dataToExtract = {
							url : fileUploadOut.file.path,
							cardtype : this.form.mbsdIDNumberType
						}
						this.form.mbsdFile = fileUploadOut.file.path;
						this.progressAction = 'Validating File...';
						this.progress = 150;
						this.$store.dispatch('EXTRACTID', {data:dataToExtract})
							.then((extractionOut) =>{
								this.loading = false;
								this.progress = 200;
								this.progressAction = 'File processed!';
								console.log('output of extraction : ', extractionOut.data)
								this.form.mbsdIDNumber = extractionOut.data.data.nik;
								// this.form.mbsdBirthDate = extractionOut.data.data.tanggal_lahir.split("-").reverse().join("-");
								this.form.mbsdBirthPlace = extractionOut.data.data.tempat_lahir;
								this.form.mbsdNationality = 'Indonesia';
								this.form.mbsdCountry = 'Indonesia';
								this.form.mbsdProvinces =  extractionOut.data.data.province;
								this.form.mbsdCity = extractionOut.data.data.city;
								this.form.mbsdAddress = extractionOut.data.data.alamat;
								this.form.mbsdRawAddress = JSON.stringify(extractionOut);
								// "mbsdFile": 'MUSTVALIDATE'
								// this.$router.push('/signup/otp')
								// this.init();
							})
							.catch(err => {
								// this.parseError(err);
								if (err.response){
									this.status = err.response;
								}
								this.loading = false;
							})
						// var 
						// this.$router.push('/signup/otp')
						// this.init();
					})
					.catch(err => {
						this.parseError(err);
						// if (err.response){
						// 	this.status = err.response;
						// }
						this.loading = false;
					})
			},
			onPhone(evt){
				evt.preventDefault()
			},
			onData(evt){
				evt.preventDefault();
				this.loading = true;
				console.log('Do profile... ', this.form);
				this.$store.dispatch('SETPROFILE', {data:this.form})
					.then((signUp) =>{
						this.loading = false;
						this.userProfile.profileComplete = true;
						this.init();
						console.log('Done signup ... ', signUp)
						// this.$router.push('/signup/otp')
					})
					.catch(err => {
						this.parseError(err);
						if (err.response){
							this.status = err.response;
						}
						this.loading = false;
					})

			},
			phoneUpdated(value){
				this.formPhone.mbspCountryCode = value.countryCallingCode;
				this.formPhone.mbspNumber = parseInt(value.phoneNumber.replace(/\D/g,''));
				// console.log(value);
			},
			sendOTP(event){
				console.log(this.formPhone)
				this.$store.dispatch('ADDPHONE', {data:this.formPhone})
					.then((addPhone) =>{
						this.loading = false;
						this.otpSent = true;
						console.log(addPhone)
						// this.$router.push('/signup/otp')
						// this.init();
					})
					.catch(err => {
						console.log('add phone error : ', err)
						// this.parseError(err);
						if (err.response){
							this.status = err.response;
						}
						this.loading = false;
					})
			},
			updateProfile(){
				console.log('Initiate update profile... ', this.userProfile.profileData.mbsdFile);
				this.$store.dispatch('CHANGEPROFILE', {data:this.userProfile.profileData.mbsdFile})
					.then(changeRequestSuccess=>{
						this.userProfile.profileComplete = false;
					})
					.catch(err=>{
						if (err.response){
							this.status = err.response;
						}
					})

			},
			doNewsCheckbox(e){
				if (e == 'accepted'){
					this.$store.dispatch('AGREENEWS', {data:{id:1}})
				}
				// this.
				// console.log(e);
			},
			init(){
				this.$store.dispatch('GETPROFILE')
					.then((profileOut)=>{
						this.$store.commit('SET_USER', {id: profileOut.data.data[0].id, user: profileOut.data});
						this.userProfile = this.$store.getters.getUserProfile;
						if (this.userProfile.memberLanguage){
							// console.log('language : ', this.userProfile.memberLanguage)
							if (this.userProfile.memberLanguage == 2){
								this.$i18n.locale = 'id';
							} else {
								this.$i18n.locale = 'en';
							}
						}
						if (!this.$store.getters.skipPhoneVerification&&!this.userProfile.phoneVerified){
							console.log('A', this.userProfile);
							if (this.userProfile.phoneData){
								this.form_.phone = this.userProfile.phoneData.mbspNumber;
								this.formPhone = userProfile.phoneData;
							}
						} else {
							this.validateLater();
						}
						if (this.userProfile.profileComplete){
							if (this.userProfile.profileData.mbsdStatus >= 1){
								this.isVerifying = false;
								this.isVerified = true;
							} else {
								this.$store.dispatch('VALIDATEID', {data:this.userProfile.profileData})
									.then(validationOut=>{
										console.log('Validation Output : ', validationOut.data)
										if (!validationOut.data.verified){
											this.isVerifying = false;
											this.isFailed = true;
											// setTimeout(()=>{ 
											// 	this.$router.push('/');
											// }, 5000);
										}
										if (validationOut.data.verifying){
											this.isVerifying = true;
										}
									})
									.catch(err=>{
										this.isVerifying = false;
										this.isFailed = true;
									})

							}
						}
						console.log('Out profile : ', this.userProfile);
					})
					.catch((err)=>{
						console.log('profile error : ', err)
					})				
			}
		},
		mounted(){
			setTimeout(()=>{ 
				this.showLater = true;
			}, 30000);
			this.countries = this.$store.getters.getCountries;
			this.$store.dispatch('CHECK')
				.then((checkOut) =>{
					// console.log(checkOut);
					this.data = checkOut.data;
					this.init();
				})
				.catch(err => {
					console.log(err);
				})
		},
	}
</script>


// WEBPACK FOOTER //
// ProfileView.vue